import React from 'react';
import { TextField } from '@mui/material';
import { Question } from '../../../types/questionnaire';
import { BaseQuestionRenderer } from './BaseQuestionRenderer';

interface TextareaRendererProps {
  question: Question;
  value: any;
  onChange: (questionName: string, value: any) => void;
}

export const TextareaRenderer: React.FC<TextareaRendererProps> = ({ question, value, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(question.name, event.target.value);
  };

  return (
    <BaseQuestionRenderer question={question}>
      <TextField
        fullWidth
        multiline
        minRows={question.attributes.rows || 4}
        variant="outlined"
        value={value}
        placeholder={question.attributes.placeholder}
        required={question.isRequired}
        onChange={handleChange}
      />
    </BaseQuestionRenderer>
  );
};
